// extracted by mini-css-extract-plugin
export default {"container":"CarProps_container__IsUQB","content":"CarProps_content__v58Fe","img":"CarProps_img__sAOz4","first":"CarProps_first__fGyUg"};